// src/utils/constants.js

// General Configurations
export const OPENAI_API_URL = 'https://api.openai.com/v1/chat/completions';

/* eslint-disable import/prefer-default-export */
export const CONSTANTS = {
  FONTS: ['Arial', 'Calibri', 'Times New Roman', 'Courier New', 'Arial Narrow', 'Georgia', 'Roboto', 'Trebuchet MS', 'Lucida Sans Unicode', 'Impact'],
  SIZES: ['6px', '7px', '8px', '9px', '10px', '11px', '12px', '13px', '14px', '15px', '16px', '18px', '20px', '24px', '28px', '32px', '36px', '40px', '44px', '48px', '52px', '60px', '72px'],
  LINE_SPACINGS: ['0.8', '0.9', '1.0', '1.2', '1.5', '1.6', '1.8', '2.0'],
  COLOR_SCHEMES: ['M1', 'Black', 'Blue', 'Dark Blue', 'Indigo Ink', 'Red', 'White', 'Pink', 'Yellow', 'Dark Mode'],
  COLOR_SCHEME_CLASSES: {
    M1: 'default-color-scheme',
    Black: 'color-scheme-black',
    Blue: 'color-scheme-blue',
    'Dark Blue': 'color-scheme-darkblue',
    'Indigo Ink': 'color-scheme-indigo-ink',
    Red: 'color-scheme-red',
    White: 'color-scheme-white',
    Pink: 'color-scheme-pink',
    Yellow: 'color-scheme-yellow',
    'Dark Mode': 'dark-mode',
  },
  MAX_PROFILES: 4,
  DEMO_CLIENT_ID: 'demo_client_id',
  DEMO_TEXT: 'demo_text',
};
